export function createToolboxXml(): string {
  return `
  <xml id="toolbox" style="display: none">

  <category name="Variables" colour="#a55b5b" >

<!--  <block type="variables_get"></block>
  <block type="variables_set"></block> -->

  <block type="set_variable"></block>
  <block type="get_variable"></block>
</category>

<!-- <category name="Functions" colour="#FF8C1A">
  <block type="procedures_defnoreturn"></block>
  <block type="procedures_defreturn"></block>
  <block type="procedures_callnoreturn"></block>
  <block type="procedures_callreturn"></block>
 <block type="custom_block"></block>
</category> -->

  <!-- Additional categories and blocks -->

  <category name="Text" colour="#5ba58c">
  <block type="text"/>
<block type="text_join"/>
<block type="text_append"/>
<block type="text_length"/>
<block type="text_isEmpty"/>
<block type="text_indexOf"/>
<block type="text_charAt"/>
<block type="text_getSubstring"/>
<block type="text_changeCase"/>
<block type="text_trim"/>
<block type="text_print"/>
<block type="text_prompt_ext"/>
<block type="string_regex_match"/>
<block type="string_contains"/>
</category>

<!-- Maps. These two lived at the bottom of Text until 2026-09-11, because reverse_geocode returns
     a string — which is true and completely unhelpful: nobody hunting for "area of" looks under
     Text. A builder searches by what the block is ABOUT, not by what it returns. -->
<category name="Maps" colour="#00897b">
<block type="polygon_area"/>
<block type="reverse_geocode"/>
<block type="point_count"/>
<block type="check_location_access"/>
<block type="ask_location_access"/>
</category>

<category name="Logic" colour="#5C81A6">
  <block type="controls_if"/>
  <block type="logic_compare"/>
  <block type="logic_operation"/>
  <block type="logic_negate"/>
  <block type="logic_boolean"/>
  <block type="logic_null"/>
  <block type="value_is_empty"/>
  <block type="logic_ternary"/>
  </category>

  <category name="Math" colour="#5C81A6">
  <block type="math_number"/>
  <block type="math_arithmetic"/>
  <block type="math_single"/>
  <block type="math_trig"/>
  <block type="trim_decimals"/>
  <block type="math_constant"/>
  <block type="math_number_property"/>
  <block type="math_round"/>
  <block type="math_on_list"/>
  <block type="math_modulo"/>
  <block type="math_constrain"/>
  <block type="math_random_int"/>
  <block type="math_random_float"/>
  <block type="number_to_words"/>
  </category>
  <category name="Time Stamp" colour="#F5A623">
  <block type="current_date_iso"/>
  <block type="set_date"/>
  <block type="set_time"/>
  <block type="date_add_days"/>
  <block type="date_start_of_month"/>
  <block type="date_end_of_month"/>
  <block type="date_start_of_day"/>
  <block type="date_end_of_day"/>
  <block type="time_difference"/>
  <!-- date_diff_hours / date_diff_minutes: SUPERSEDED by time_difference (2026-08-27). Hidden from the
       palette but their block defs, VALID_BLOCK_TYPES entry and all three compilers stay, so saved
       functions using them keep loading and compiling.
  <block type="date_diff_hours"/>
  <block type="date_diff_minutes"/>
  -->
  <block type="parse_date_to_iso"/>
  <block type="format_iso_date"/>
  </category>
  <category name="Loops" colour="#5CA65C">
  <block type="controls_repeat_ext"/>
  <block type="controls_whileUntil"/>
  <block type="controls_forEach"/>
  <block type="controls_flow_statements"/>
  <block type="custom_loop"/>
</category>

  <!-- Removed 2026-07-09: stale "function Variables" + standard "List" toolbox categories (were already
       disabled/commented). Archived in docs/archive/stale-blocks/. push_to_entity_list stays REGISTERED
       (227 saved uses) but intentionally NOT in the toolbox (deprecated for push_new_element_to_array). -->
  <category name="Entity Variable" colour="#89F336">
  <block type="set_entity_variable"></block>
  <block type="get_entity_variable"></block>
  <block type="set_entity_variable_by_index_of_entity_list"></block>
  <block type="set_reference_entity_variable_for_AOB"></block>
  <block type="get_reference_entity_variable_for_AOB_reference_AOB"></block>
  <block type="set_key_value_in_AOB_reference"></block>
  <block type="set_aob_variable"></block>
  <block type="get_aob_variable"></block>
  <block type="set_entity_list_variable"></block>
  <block type="get_entity_list_variable"></block>
  <block type="push_new_element_to_array"/>
  <!-- push_to_entity_list hidden 2026-06-28: redundant with push_new_element_to_array — its generator
       calls getVariableByMultiData(...,[]) (empty multiDataIndex) so it adds no drill-down, and only
       handles local/global top lists (a strict subset of getArrayElement). Definition + generator are
       kept registered so the existing functions that use it still load/run.
       See docs/plans/push-blocks-analysis-and-restriction.md -->
  <block type="get_entity_length"/>
  <block type="delete_from_entity_list"/>
      </category>

  <category name="Query" colour="#000000">
  <block type="get_query"></block>
  <!-- DEPRECATED 2026-06-27: sorting now via the add_order block (Conditions category). Kept registered for old fns.
  <block type="get_set_order_variable"></block> -->
  <!-- DEPRECATED 2026-06-26 (Phase 3.5): the 13 typed condition blocks are superseded by the
       "Conditions" category (add_condition / condition_group / clear_conditions). Hidden from the
       toolbox but kept REGISTERED (block defs in query-helper.ts) so old saved functions still load.
       Un-comment only for legacy repair. The get_query "Where Conditions" socket is left intact
       (additive — old functions keep working; new functions use the Conditions blocks).
  <block type="entity_conditions"></block>
  <block type="entity_or_conditions"></block>
  <block type="entity_set_string_in_conditions"></block>
  <block type="entity_string_conditions"></block>
  <block type="entity_set_time_stamp_in_conditions"></block>
  <block type="entity_time_stamp_conditions"></block>
  <block type="entity_set_number_in_conditions"></block>
  <block type="entity_number_conditions"></block>
  <block type="entity_set_boolean_in_conditions"></block>
  <block type="entity_boolean_conditions"></block>
  <block type="entity_set_id_in_conditions"></block>
  <block type="entity_id_conditions"></block>
  <block type="entity_is_null_conditions"></block>
  -->
  <block type="update_entity"></block>
  <block type="create_entity"></block>
  <block type="entity_reference_selection"></block>
  <block type="async_function_wrapper"></block>
  <block type="resolve_promise_by_group"></block>
  <!-- DEPRECATED 2026-06-27: the AAOB filter / has-key blocks are superseded by the Conditions blocks —
       add_condition on an AAOB field does value filters (= ≠ < > in) AND "has this key" / "missing this key".
       They also output into the now-removed get_query CONDITIONS socket, so they're unpluggable. Kept
       registered (defs in query-helper.ts) so old saved functions still load.
  <block type="aaob_filter_by_label"></block>
  <block type="aaob_label_exists"></block>
  -->
  <!-- DEPRECATED 2026-06-27: AAOB sort now via add_order (AAOB field + value type). Kept registered for old fns.
  <block type="aaob_sort_by_label"></block> -->
  <block type="entity_aggregate_query"></block>
  <!-- HIDDEN 2026-06-23: AAOB aggregate parked for now; re-enable in future. Block stays registered (loads in saved fns). -->
  <!-- <block type="aaob_aggregate_by_label"></block> -->

  </category>
  <category name="Conditions" colour="#3a6ea5">
  <block type="add_condition"><field name="ONMISSING">false</field></block>
  <block type="condition_group"></block>
  <block type="clear_conditions"></block>
  <block type="add_order"></block>
  <block type="clear_orders"></block>
  </category>
  <category name="Special Functions" colour="#ff0000">
  <block type="show_loading_screen"/>
  <block type="get_current_user"/>
  <block type="get_current_user_role"/>
  <block type="get_roles_list"/>
  <!-- create_user / edit_user retired (superseded by 'add user' + the owner admin page). 'invite user to my
       tenant' (tenant_add_user) was retired from the palette too (2026-09-02, f4320c70): 'add user' by email
       sends the same invitation, so offering both would be two blocks for one job.
       get_users_list ALSO retired (2026-09-01): bind a table directly to the systemOotbUser entity instead
       (raw rows, tenant-scoped, gated by the role's read grant). All three defs + codegen stay registered
       so existing wired pages keep working; just not offered anew. -->
  <block type="tenant_cancel_invite"/>
  <block type="tenant_edit_user_role"/>
  <block type="user_create_account"/>
  <block type="user_set_email"/>
  <block type="user_set_username"/>
  <block type="user_reset_password"/>
  <block type="user_change_password"/>
  <block type="user_delete_account"/>
  <block type="person_remove"/>
  <block type="person_reinstate"/>
  <block type="person_erase"/>
  <block type="person_transfer"/>
  <block type="delete_record"/>
  <block type="meta_page_subscription"/>
  <block type="get_email"/>
  <block type="app_version"/>
  <block type="set_navigation"/>
  <block type="open_external_string"/>
  <block type="logout_user"/>
  <block type="show_toast"/>
  </category>
  <category name="API" colour="#a61580">
  $REPLACE
  </category>
  <category name="Bastion Flows" colour="#0f766e">
  $BASTION_FLOWS
  </category>
</xml>
  `;
}

/**
 * Restricted toolbox for the SANDBOXED landing page (Track C / public-landing-and-signup.md).
 *
 * The anonymous-tier capability boundary is enforced by what can be PLACED on the page: only
 * value primitives + localVariables + Logic (if/compare — pure control-flow, e.g. branch on the
 * login/signup result string) + the system Auth palette + the async-flow pair (group wrap /
 * resolve — pure control-flow over `this.__asyncGroups`, no data access, needed to await the
 * now-async login/signup). Deliberately EXCLUDED: Entity Variable, Query, Special Functions
 * (navigation/users/etc.), API, Workflows, globalVariables. The page structurally cannot read
 * data, navigate, or touch entities.
 */
export function createSandboxedToolboxXml(): string {
  return `
  <xml id="toolbox" style="display: none">
  <category name="Variables" colour="#a55b5b">
  <block type="set_variable"></block>
  <block type="get_variable"></block>
  </category>
  <category name="Text" colour="#5ba58c">
  <block type="text"/>
  <block type="text_join"/>
  <block type="text_length"/>
  <block type="text_isEmpty"/>
  <block type="text_trim"/>
  </category>
  <category name="Math" colour="#5C81A6">
  <block type="math_number"/>
  <block type="math_arithmetic"/>
  </category>
  <category name="Logic" colour="#5C81A6">
  <block type="controls_if"/>
  <block type="logic_compare"/>
  <block type="logic_operation"/>
  <block type="logic_negate"/>
  <block type="logic_boolean"/>
  <block type="logic_null"/>
  <block type="value_is_empty"/>
  <block type="logic_ternary"/>
  </category>
  <category name="Auth" colour="#2e7d32">
  <block type="auth_login"/>
  <block type="auth_send_password_reset"/>
  <block type="auth_signup_found"/>
  </category>
  <category name="Async" colour="#4a90e2">
  <block type="async_function_wrapper"/>
  <block type="resolve_promise_by_group"/>
  </category>
  <category name="App" colour="#607d8b">
  <block type="app_version"/>
  </category>
</xml>
  `;
}
